import { useParams } from "react-router-dom";
import classes from "./Category.module.css"
import HelpCenterBreadCrumbs from "./components/HelpCenterBreadCrumb"

const articlesAssetsData = [
    {
        title: "How to switch between different accounts",
        link: ""
    },
    {
        title: "How to view MT5 Login",
        link: ""
    },
    {
        title: "How to download the assets portfolio",
        link: ""
    },
    {
        title: "How to see statistics",
        link: ""
    },
    {
        title: "How to see monthly gains",
        link: ""
    },
    {
        title: "How to see the open and closed trades",
        link: ""
    }
]

const articlesTransactionsData = [
    {
        title: "What methods can I use to add funds to my account?",
        link: ""
    },
    {
        title: "How to add funds via wire transfer",
        link: ""
    },
    {
        title: "How to add funds via crypto",
        link: ""
    },
    {
        title: "What methods can I use to send funds from my account?",
        link: ""
    },
    {
        title: "How to send funds via wire transfer",
        link: ""
    },
    {
        title: "How to send funds via crypto",
        link: ""
    },
    {
        title: "How will I know my service fee?",
        link: ""
    },
    {
        title: "How can I see service fee history?",
        link: ""
    }
]

const articlesTeamData = [
    {
        title: "How can I add a team member to my company?",
        link: ""
    },
    {
        title: "How can I see the team members of my company?",
        link: ""
    },
    {
        title: "How can I remove a team member?",
        link: ""
    },
    {
        title: "How can I see user access?",
        link: ""
    },
    {
        title: "How can I edit user access?",
        link: ""
    },
    {
        title: "How does the team member accept the invite?",
        link: ""
    }
]

const Article = () => {
    const params = useParams();

    return (
        <div>Article</div>
        // <div className={`${classes.wrapper} container`}>
        //     <HelpCenterBreadCrumbs mainText={params.id === "assets" ? "My Assets" : params.id === "transactions" ? "Transactions" : params.id === "team" && "Team" } search={true} root="/dashboard/help" rootText="Help Center"/>
        // <div>
        // </div>

        // {params.id === "assets" && <><h6>Articles</h6>
        // {articlesAssetsData.map((item, i) => (<div className={classes.articleTitle} key={i} onClick={() => {}} role="button">
        //         {item.title}
        // </div>))}
        // </>}

        // {params.id === "transactions" && <><h6>Articles</h6>
        // {articlesTransactionsData.map((item, i) => (<div className={classes.articleTitle} key={i}>
        //         {item.title}
        // </div>))}
        // </>}
        // {params.id === "team" && <><h6>Articles</h6>
        // {articlesTeamData.map((item, i) => (<div className={classes.articleTitle} key={i}>
        //         {item.title}
        // </div>))}
        // </>}
        // </div>
        
    )
}

export default Article